module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-jp-7f36ddb4c8698780730c4bf23365b849.svg";